var irreducible = require('./irreducible');
var isString = require('./isString');

module.exports = irreducible('String', isString);
